module.exports = __webpack_public_path__ + "static/media/dessert.85e9cf03.png";